import { Component, OnInit } from '@angular/core';
import { ToastNotificationService } from 'app/shared/toast-notification/toast-notification.service';
import { INT_WFACTION_TYPE_ACTIONS, WFACTION_TYPE_ACTIONS } from "app/shared/actions/actions.constants";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { WorkflowService } from 'app/services/workflow.service';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { actionsdto } from 'app/models/actionsdto';
import { AuthWebService } from 'app/services/authweb.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-wfactions',
  templateUrl: './wfactions.component.html',
  styleUrls: ['./wfactions.component.scss']
})
export class WFActionsComponent implements OnInit {
  actionsdto: actionsdto = new actionsdto;
  actions: any = [];
  selectedData: any = null;
  selectedStatusData: any = null;
  isLoading: boolean = false;
  lblHeading = "Manage Workflow Actions";
  user: any = {};
  mode:any = 'Add';

  wfStatusTypeActions = INT_WFACTION_TYPE_ACTIONS;

  constructor(private service: WorkflowService, private toaster: ToastNotificationService, 
    private authWebService: AuthWebService, private datePipe: DatePipe,
    public utility: UtilityServiceService, private dialog: ConfirmDialogService) { }

  ngOnInit(): void {
    this.user = this.authWebService.userData.User
    this.getActions();
  }

  //#region General
  onChecked(event, item){
    if (event.target.checked) {
      this.selectedStatusData = item;
    } else {
      this.selectedStatusData = null;
    }
  }

  doPermitAction(event: any) {
    const button = document.getElementById("popupButton") as HTMLButtonElement;
    if (event.value == WFACTION_TYPE_ACTIONS.AddWFAction) {
      this.lblHeading = "Add Action";
      this.mode = 'Add';
      this.actionsdto = new actionsdto;
      button.click();
    } else if (event.value == WFACTION_TYPE_ACTIONS.DeleteWFAction) {
      if(this.selectedStatusData == null){
         this.toaster.error("Please select the record first!","Delete")
       }else{
        this.actionsdto = this.selectedStatusData;
         this.onDelete();
       }
    } else if (event.value == WFACTION_TYPE_ACTIONS.EditWFAction) {
      this.lblHeading = "Edit Action";
      this.mode = 'Edit';
      if(this.selectedStatusData == null){
        this.toaster.error("Please select the record first!","Edit")
      }else{
        this.actionsdto = this.selectedStatusData;
        button.click();
      }
    }
  }
  //#endregion

  //#region CRUD
  getActions(){
    this.isLoading = true;
    this.service.getWorkflowAction().subscribe(
      (result) => {
        this.actions = result;
        this.isLoading = false;
      },
      (error) => {
        this.toaster.error(
          "Failed to load actions. Please try again",
          "Workflow Status"
        );
        this.isLoading = false;
      }
    );

  }

  onAdd(){

    if(this.actions.find(x=>x.name==this.actionsdto.name)){
      this.toaster.error("Action already exists!","Action");
      return;
    }

    if(this.actions.find(x=>x.code==this.actionsdto.code)){
      this.toaster.error("Code already exists!","Action");
      return;
    }

    this.actionsdto.usercreated = this.user.Id;
    this.actionsdto.datecreated = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.actionsdto.userupdated = this.user.Id;
    this.actionsdto.dateupdated = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.actionsdto.deletedyn = false;

    this.isLoading = true;
    this.service.addWorkflowAction(this.actionsdto).subscribe(
      (result) => {
        const button = document.getElementById("popupButton") as HTMLButtonElement;
        button.click();
        this.toaster.success("Action successfully added","Action");
        this.getActions();
      },
      (error) => {
        this.toaster.error(
          "Failed to save action. Please try again",
          "Workflow Action"
        );
        this.isLoading = false;
      }
    );
  }

  onUpdate(){

    if(this.actions.find(x=>x.name==this.actionsdto.name && x.actionsid != this.actionsdto.actionsid)){
      this.toaster.error("Action already exists!","Action");
      return;
    }

    if(this.actions.find(x=>x.code==this.actionsdto.code && x.actionsid != this.actionsdto.actionsid)){
      this.toaster.error("Code already exists!","Action");
      return;
    }

    this.isLoading = true;
    this.service.updateWorkflowAction(this.actionsdto.actionsid, this.actionsdto).subscribe(
      (result) => {
        const button = document.getElementById("popupButton") as HTMLButtonElement;
        button.click();
        this.toaster.success("Action successfully updated","Action");
        this.getActions();
      },
      (error) => {
        this.toaster.error(
          "Failed to update action. Please try again",
          "Workflow Action"
        );
        this.isLoading = false;
      }
    );
  }

  onDelete(){
    this.dialog.confirmThis(`Are you sure you want to delete this action.`,
    () => {
      this.isLoading = true;      
      this.service.deleteWorkflowAction(this.actionsdto.actionsid).subscribe(
        (result) => {
          this.toaster.success("Action successfully deleted","Action");
          this.getActions();
        },
        (error) => {
          this.toaster.error(
            "Failed to update action. Please try again",
            "Workflow Action"
          );
          this.isLoading = false;
        }
      );
    },
    () => {
      this.isLoading = false;
      return;
    }
  );

  }
  //#endregion
}
